import { PermissionComponent } from "../../components";

export default function UsersPage() {
  return <PermissionComponent.UsersPage />;
}
